import { LocationStrategy } from "@angular/common";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IBaseModel } from "../models/base.model";
import { IOsaExecucaoCronogramaModel, IOsaExecucaoFaseAtividadeModel } from "../models/osa-execucao-cronograma-model";
import { BaseService } from "./base.service";

@Injectable({
    providedIn: 'root',
})
export class OsaExecucaoCronogramaService extends BaseService {

    constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
        super(httpClient, locationStrategy);
    }

      public async obterCronograma(osaExecucaoId :number): Promise<IBaseModel<IOsaExecucaoCronogramaModel>> {
        return this.httpClient
          .get<IBaseModel<IOsaExecucaoCronogramaModel>>(`${this.apiBaseUrl}/osaExecucaoCronograma/${osaExecucaoId}`)
          .toPromise();
      }

      public async inserirAtividade(data: IOsaExecucaoFaseAtividadeModel): Promise<IBaseModel<void>> {
        return this.httpClient
          .post<IBaseModel<void>>(`${this.apiBaseUrl}/osaExecucaoCronograma/atividade`, data )
          .toPromise();
      }

      public async atualizarAtividade(model: any): Promise<IBaseModel<void>> {
        return this.httpClient
          .put<IBaseModel<void>>(`${this.apiBaseUrl}/osaExecucaoCronograma/atividade`, model)
          .toPromise();
      }

      public async excluirAtividade(id: number): Promise<IBaseModel<void>> {
        return this.httpClient
          .delete<IBaseModel<void>>(`${this.apiBaseUrl}/osaExecucaoCronograma/${id}/excluir-atividade`, {})
          .toPromise ();
      }

    }
